import React, { useState } from 'react'
import { toast } from 'sonner'
import axios from 'axios'
import { PlusIcon } from '@heroicons/react/24/solid'
import { Dialog, DialogBody, DialogFooter, DialogHeader } from '@material-tailwind/react'

const initialScraper = {
  scraperId: '',
  name: '',
  category: '',
  scrapeBy: 'Style Number',
}

export function AddScraper({ handleCallBackState }) {
  const [open, setOpen] = useState(false)
  const [scraperData, setScraperData] = useState(initialScraper)
  const [isSaving, setIsSaving] = useState(false)

  const handleOpen = () => setOpen((previous) => !previous)

  const handleAddScraper = (event) => {
    event.preventDefault()
    const { scraperId, name, category } = scraperData
    if (!scraperId || !name || !category) {
      toast.error('Enter an ID, name, and category.')
      return
    }

    setIsSaving(true)
    axios
      .post('/api/webscrapers/add', scraperData)
      .then((response) => {
        if (response.data.message) {
          toast.success(response.data.message)
          setScraperData(initialScraper)
          setOpen(false)
          handleCallBackState()
        } else {
          toast.error('The scraper could not be added.')
        }
      })
      .catch((error) => {
        console.error('Error:', error)
        toast.error(error.response?.data?.message || 'The scraper could not be added.')
      })
      .finally(() => setIsSaving(false))
  }

  return (
    <>

      <button type="button" onClick={handleOpen} className="nx-btn-primary">
        <PlusIcon className="h-4 w-4" />
        Add scraper
      </button>

      <Dialog
        className="border border-rule bg-raised text-paper shadow-panel"
        size="sm"
        open={open}
        handler={handleOpen}
      >
        <form onSubmit={handleAddScraper}>
          <DialogHeader className="flex-col items-start border-b border-rule text-paper">
            <p className="nx-manifest-kicker">Inventory</p>
            <h2 className="mt-1 font-display text-2xl tracking-wide">Add scraper</h2>
            <p className="mt-1 text-sm font-normal text-muted">
              Register a scraper so it can be selected in new requests.
            </p>
          </DialogHeader>
          <DialogBody className="grid gap-4 text-paper sm:grid-cols-2">
            <div>
              <label htmlFor="scraper-id" className="nx-label">
                Identifier
              </label>
              <input
                id="scraper-id"
                className="nx-input"
                required
                value={scraperData.scraperId}
                onChange={(event) =>
                  setScraperData({ ...scraperData, scraperId: event.target.value })
                }
                placeholder="brand-public"
              />
            </div>
            <div>
              <label htmlFor="scraper-name" className="nx-label">
                Name
              </label>
              <input
                id="scraper-name"
                className="nx-input"
                required
                value={scraperData.name}
                onChange={(event) =>
                  setScraperData({ ...scraperData, name: event.target.value })
                }
                placeholder="Brand name"
              />
            </div>
            <div>
              <label htmlFor="scraper-category" className="nx-label">
                Category
              </label>
              <select
                id="scraper-category"
                className="nx-input"
                required
                value={scraperData.category}
                onChange={(event) =>
                  setScraperData({ ...scraperData, category: event.target.value })
                }
              >
                <option value="">Choose category</option>
                <option value="public">Public site</option>
                <option value="b2b">B2B site</option>
              </select>
            </div>
            <div>
              <label htmlFor="scrape-by" className="nx-label">
                Scrape by
              </label>
              <input
                id="scrape-by"
                className="nx-input"
                value={scraperData.scrapeBy}
                onChange={(event) =>
                  setScraperData({ ...scraperData, scrapeBy: event.target.value })
                }
              />
            </div>
          </DialogBody>
          <DialogFooter className="gap-2 border-t border-rule">
            <button type="button" className="nx-btn-ghost" onClick={handleOpen}>
              Cancel
            </button>
            <button type="submit" className="nx-btn-primary" disabled={isSaving}>
              {isSaving ? 'Adding scraper' : 'Add scraper'}
            </button>
          </DialogFooter>
        </form>
      </Dialog>
    </>
  )
}
